import { FC, useState } from 'react';
import { Divider } from '@belong/ui-core';
import { FieldsetElement } from '../../forms/Fieldset/Fieldset';
import { Heading } from '../../styles/Typography/Heading';
import { TEST_ID } from './constants';
import { Container } from './FeedbackCapture.styles';
import { FeedbackCaptureSteps } from './steps';
import { FeedbackStep, IFeedbackCapture } from './steps/Steps.types';

/**
 * Multi-step mechanism to capture user feedback.
 *
 * Results/input is currently recorded using analytics platforms
 */
export const FeedbackCapture: FC<IFeedbackCapture> = ({ heading, optionLabels, successMessage, ...props }) => {
  const [currentStep, setCurrentStep] = useState<FeedbackStep>(FeedbackStep.INITIAL);
  const Step = FeedbackCaptureSteps[currentStep];

  const next = () => {
    if (Step.next) {
      setCurrentStep(Step.next);
    }
  };

  const stepProps = {
    optionLabels,
    successMessage,
    next
  };

  return (
    <Container data-testid={props['data-testid'] ?? TEST_ID.COMPONENT}>
      <Divider />
      <FieldsetElement>
        <legend>
          <Heading data-testid={TEST_ID.HEADING} variant="small" as="h2" alignment="left">
            {heading}
          </Heading>
        </legend>
        <Step.Component {...stepProps} />
      </FieldsetElement>
    </Container>
  );
};

FeedbackCapture.displayName = 'FeedbackCapture';
